import { debugDir, debugLog } from '../../logger';
import React from "react";
import { setPageTitle, errorToText, Marger } from "../../helpers";
import { RouteComponentProps } from "react-router-dom";
import Settings, { LoginStatus } from "../../Settings";
import EmbeddedError from "../Errors/Errors";
import { Alert } from "@material-ui/lab";
import HistoryTable from "./HistoryTable";
import { Link as RouterLink } from "react-router-dom";
import { getHistory } from "../../HistoryHelper";
import { ReadedJobFiles, RawJobDoc } from "../../types/entities";
import ApiHelper from "../../ApiHelper";
import {
  Container,
  Link,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@material-ui/core";

// Icon <Icon className="fas fa-camera" />

type MyHistoryState = {
  jobs: RawJobDoc[];
  updateState: number; //timestamp
  loaded: boolean;
  status?: "error" | "not_found";
};
export interface HistoryAnyJob {
  // from backend controller/route/history/get.ts
  gro: string;
  itps: { name: string; content: string }[];
}

export class MyHistory extends React.Component<
  RouteComponentProps,
  MyHistoryState
> {
  state: MyHistoryState = {
    jobs: [],
    updateState: Date.now(),
    loaded: false,
  };

  componentDidMount() {
    if (Settings.logged === LoginStatus.None) {
      return;
    }
    setPageTitle("My history");
    getHistory()
      .then((jobs) => {
        this.setState({ jobs, loaded: true });
      })
      .catch((err) => this.dealWithGetHistoryError(err));
  }

  componentDidUpdate(_: any, old_state: MyHistoryState) {
    if (this.state.updateState !== old_state.updateState) {
      this.setState({ loaded: false });
      getHistory()
        .then((jobs) => {
          this.setState({ jobs, loaded: true });
        })
        .catch((err) => this.dealWithGetHistoryError(err));
    }
  }

  dealWithGetHistoryError(err: any) {
    const e = errorToText(err);
    if (e === "History not found.")
      this.setState({ status: "not_found", jobs: [], loaded: true });
    else this.setState({ status: "error", jobs: [], loaded: true });
  }

  render() {
    if (Settings.logged === LoginStatus.None) {
      return (
        <EmbeddedError title="Forbidden" text="You can't access this page." />
      );
    }

    return (
      <Container style={{ paddingTop: 14 }}>
        <Typography variant="h3" className="page-title">
          History
        </Typography>

        <Typography style={{ marginBottom: "1rem" }}>
          This page contains all jobs you've submitted.
        </Typography>

        {!this.state.loaded && <CircularProgress />}

        {this.state?.jobs.length >= 1 && this.state.loaded && (
          <HistoryTable
            jobs={this.state.jobs}
            onNeedUpdate={() => {
              this.setState({ updateState: Date.now() });
            }}
          />
        )}
        {this.state.status === "not_found" && this.state.loaded && (
          <Alert variant="outlined" severity="info">
            No jobs have been found in your history. Use{" "}
            <Link component={RouterLink} to="/builder">
              {" "}
              Molecule Builder{" "}
            </Link>
          </Alert>
        )}

        {this.state.status === "error" && this.state.loaded && (
          <Alert variant="outlined" severity="error">
            Server error occured. Impossible to retrieve your history.
          </Alert>
        )}
      </Container>
    );
  }
}

export default MyHistory;

interface MHSProps {
  open: boolean;
  onChoose(ff: string, molecule: ReadedJobFiles): any;
  onCancel(): any;
  ff?: string;
}
export class ModalHistorySelector extends React.Component<MHSProps, any> {
  timeout: NodeJS.Timeout | undefined;

  state: any = {
    search: "",
    loading: false,
    molecules: [],
    load_more: false,
    content: "",
    jobs: [],
  };

  chosen = false;

  componentDidMount() {
    if (Settings.logged === LoginStatus.None) {
      return;
    }
  }

  componentDidUpdate(
    prevProps: Readonly<{
      open: boolean;
      onChoose(ff: string, molecule: ReadedJobFiles): any;
      onCancel(): any;
    }>,
    prevState: Readonly<any>,
    snapshot?: any,
  ): void {
    if (this.props.open && prevProps.open !== true) {
      if (Settings.logged === LoginStatus.None) {
        return;
      }

      getHistory()
        .then((jobs) => {
          debugLog("getHistory");
          debugDir(jobs);
          if (this.props.ff) {
            const ff = this.props.ff;
            jobs = jobs.filter((j) => j?.settings.ff.startsWith(ff));
          }
          this.setState({ jobs, loaded: true });
        })
        .catch((err) => {
          debugLog("OUPS");
          this.setState({ oups: false });
        });
    }
  }

  async molecule_to_itp(obj: any) {
    debugLog("molecule to itp");
    const forcefield = obj["settings"]["ff"];
    try {
      const res: any = await ApiHelper.request(`history/get?jobId=${obj.id}`);
      console.warn(
        `MyHistory:modalHistorySelector:molecule_to_itp: history/get?jobId=${obj.id}`,
      );
      debugDir(res);
      if (!Object(res).hasOwnProperty("files"))
        throw new Error("History files not missing");

      const files: ReadedJobFiles = res.files;
      this.props.onChoose(forcefield, files);
    } catch (e) {
      console.error(e);
      this.setState({ oups: true });
      debugLog("Error while loading molecules.");
    }
  }

  onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();

    this.setState({ search: e.target.value, oups: false });

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }

    const content = e.target.value.trim();
    if (content) {
      this.timeout = setTimeout(() => {
        this.timeout = undefined;
      }, 350);
    } else {
      this.setState({
        content: "",
        molecules: [],
        load_more: false,
        loading: false,
        oups: false,
      });
    }
  };

  onLoadMore = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  render() {
    const jobsToShow = this.state.jobs.filter(
      (m: any) => m.type === "martinize",
    );
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onCancel}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Find a{" "}
          <span style={{ color: "steelblue" }}>{this.props.ff || ""} </span>{" "}
          molecule in your history
        </DialogTitle>
        {this.state.oups && (
          <Alert severity="warning">Error while loading molecules.</Alert>
        )}
        <DialogContent>
          <div>
            <TextField
              value={this.state.search}
              onChange={this.onInputChange}
              placeholder="Enter a query..."
              style={{ width: "100%" }}
              variant="outlined"
            />
          </div>

          <Marger size="1rem" />

          <List>
            {/* We curretnly filter & keep only martinize */}
            {jobsToShow.map((m: any) => (
              <ListItem
                key={m.id}
                button
                onClick={() => {
                  if (!this.chosen) this.molecule_to_itp(m);
                  this.chosen = true;
                }}
              >
                <ListItemText
                  primary={
                    /*m.type === "martinize"
                        ?*/
                    `${m.type} [${m.settings.builder_mode} | ${m.settings.ff}]\t${m.name} (${m.date})`
                    // : `${m.type} | ${m.settings.ff})\t${m.name} (${m.date})`
                  }
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>

        <DialogActions>
          <Button color="secondary" onClick={this.props.onCancel}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
